import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    Router
} from '@angular/router';

@Injectable()
export class ResetPasswordGuardService implements CanActivate {
    constructor(private router: Router) {}

    public canActivate(
        route: ActivatedRouteSnapshot,
    ): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            const codeParam = route.queryParams['code'];
            console.log('codeParam', codeParam);
            if (!codeParam) {
                resolve(false);
                this.router.navigate(['']);
            }

            resolve(true);
        });
    }
}